__turbopack_context__.v({
  "alert": "flexibleFormAlert-module-scss-module__cgJuGq__alert",
  "content": "flexibleFormAlert-module-scss-module__cgJuGq__content",
  "iconSvg": "flexibleFormAlert-module-scss-module__cgJuGq__iconSvg",
  "leadIn": "flexibleFormAlert-module-scss-module__cgJuGq__leadIn",
  "leadingIcon": "flexibleFormAlert-module-scss-module__cgJuGq__leadingIcon",
  "message": "flexibleFormAlert-module-scss-module__cgJuGq__message",
  "toneCritical": "flexibleFormAlert-module-scss-module__cgJuGq__toneCritical",
  "toneInfo": "flexibleFormAlert-module-scss-module__cgJuGq__toneInfo",
  "toneOffer": "flexibleFormAlert-module-scss-module__cgJuGq__toneOffer",
  "toneSuccess": "flexibleFormAlert-module-scss-module__cgJuGq__toneSuccess",
  "toneWarning": "flexibleFormAlert-module-scss-module__cgJuGq__toneWarning",
});
